var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"top","trigger":"hover"}},[_c('el-tag',{attrs:{"type":"warning"}},[_c('i',{staticClass:"el-icon-info",staticStyle:{"margin-right":"4px"}}),_vm._v("\n    "+_vm._s(_vm.getServiceName())+" : "+_vm._s(_vm.getRecordName())+"\n  ")]),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v("In Use!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }